import React, { ReactNode } from 'react';
import { TCommonData, TItem } from './widget/data';
import { TWidgetCommonOption } from './widget/options';
import { TWidget } from './widget/widget';

export type TGroupWidgetProps<TD, TWE, TO = TWidgetCommonOption> = {
    widgetId: TWE;
} & TWidgetProps<TD, TO>;

export type TWidgetProps<TD, TO = TWidgetCommonOption> = {
    widget: TWidget<TD, TO>;
    children?: ReactNode;
};

export type TMainWidgetProps = {
    uid?: TWidget<TCommonData>['uid'];
    widget?: TWidget<TCommonData>;
    Package: React.ElementType;
};

export type TRowComponentProps = {
    flagIcon?: string;
    isSelected?: boolean;
} & TItem &
    Pick<TWidgetCommonOption, 'isDisabled' | 'isHide' | 'parentStyleNames' | 'isError'>;
